document.addEventListener("DOMContentLoaded", function() {
    fetch("https://gold-prices-pakistan.p.rapidapi.com/live", {
        method: "GET",
        headers: {
            "x-rapidapi-host": "gold-prices-pakistan.p.rapidapi.com",
            "x-rapidapi-key": "36cdad6226mshd51034a24579af3p17f887jsn8df624249880" // Replace with your actual API key
        }
    })
    .then(response => response.json())
    .then(data => {
        console.log(data); // Log the response to understand its structure
        
        if (data) {
            // Extract 24k prices
            let goldPrice24k1Tola = data["1 Tola"] ? data["1 Tola"][0] : "N/A";
            
            // Convert to 22k and 21k
            let goldPrice22k1Tola = goldPrice24k1Tola * 0.9167;
            let goldPrice21k1Tola = goldPrice24k1Tola * 0.875;

            // Display 24k prices
            document.getElementById("gold-price-24k-1-tola").innerText = "1 Tola (24k): " + goldPrice24k1Tola.toFixed(2) + " PKR";

            // Display 22k prices
            document.getElementById("gold-price-22k-1-tola").innerText = "1 Tola (22k): " + goldPrice22k1Tola.toFixed(2) + " PKR";

            // Display 21k prices
            document.getElementById("gold-price-21k-1-tola").innerText = "1 Tola (21k): " + goldPrice21k1Tola.toFixed(2) + " PKR";

            // Add animation class
            document.querySelectorAll("#gold-prices div").forEach(div => {
                div.classList.add("visible");
            });
        } else {
            document.querySelectorAll("#gold-prices div").forEach(div => {
                div.innerText = "Gold Price: Data not available";
            });
        }
    })
    .catch(err => {
        console.error(err);
        document.querySelectorAll("#gold-prices div").forEach(div => {
            div.innerText = "Gold Price: Error fetching data";
        });
    });
});
